import React from 'react'
import styled from 'styled-components'
import { colors, media } from '../styles/vars'

const Container = styled.div`
padding:15px;
background-color:#323031;
width:90%:
margin:0 auto;
height:100%;

${
    media.desktop`
    padding:20px;
    `
    }
`
const ImageContainer = styled.div`
width:90%;
margin:0 auto;
padding:5px;
border:1px solid #373737;
border-radius:2px;
background-color:#292929;
display:${props => props.placehold ? 'none' : 'block'};

${
    media.desktop`
    width:60%;
    transition:opacity .6s, visibility .6s;
    display:block;
    ${props => props.placehold ? `
    padding-bottom:35%;
    visibility:hidden;
    opacity:0;
    ` : ''}
    `
    }
`
const Image = styled.div`
background-repeat:no-repeat;
background-size:cover;
background-position:center top;
background-image:url(${props => `./static/images/timeline/${props.imageName}.jpg`});
padding-bottom:50%;
${
    media.desktop`
    padding-bottom:60%;
    `
    }
`
const Paragraph = styled.p`
margin-top:10px;
font-size:2rem;
color:${colors.white};
text-align:justify;
font-weight:100;
line-height:1.2;
${
    media.desktop`
    font-size:2.4rem;
    `
    }
`
const Content = styled.div`
${
    media.desktop`
    width:45%;
    float:left;
    height:100%;
    `
    }
    ${
    media.middle`
        width:37%;
        `
    }
`
const TimelineYearDetails = (props) => {
    const getImage = () => {
        if (props.hideImage)
            return <ImageContainer placehold></ImageContainer>;
        return (
            <ImageContainer>
                <Image imageName={props.year} />
            </ImageContainer>
        )
    }
    return (
        <Container>
            <Content>
                {getImage()}
                <div>
                    <Paragraph>{props.description}</Paragraph>
                </div>
            </Content>
        </Container>
    )
}

export default TimelineYearDetails;


// WEBPACK FOOTER //
// ./src/components/TimelineYearDetails.jsx